//const baseUrl = "http://192.168.168.57:8080/ors/";
const baseUrl = "https://api.onlineroadservices.com/"

const BaseUrl={
    baseUrl
};

export default BaseUrl;